import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import { CharacteristicsDDLModel } from '../../../common/viewModels/GlobalRegistry/GraphTempModel';

@Component({
  selector: 'addeditgraphconfig',
  templateUrl: './addeditgraphconfig.component.html',
  styleUrls: ['./addeditgraphconfig.component.scss']
})

export class AddEditGraphConfigComponent implements OnInit {

  graphForm: FormGroup;
  isSubmitted: boolean = false;
  lstCharacteristics: CharacteristicsDDLModel[];
  graphTypes: any;
  id: number;
  count1: number;
  count2: number;
  count3: number;
  count4: number;
  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _validationService: ValidationService, private _mApp: MainAppComponent,
    private _toastrService: ToastrService) {

  }

  ngOnInit() {
    this.id = this._route.snapshot.params['id'];
    this.graphForm = this._formBuilder.group({
      'Graph1': this._formBuilder.group({
        GraphConfigId: [0],
        GraphTemplateTypeId: [this.id],
        GraphDesc: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
        charIds: [''],
        GraphOrderId: [1],
        GraphTypeId: [0]
      }),
      'Graph2': this._formBuilder.group({
        GraphConfigId: [0],
        GraphTemplateTypeId: [this.id],
        GraphDesc: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
        charIds: [''],
        GraphOrderId: [2],
        GraphTypeId: [0]
      }),
      'Graph3': this._formBuilder.group({
        GraphConfigId: [0],
        GraphTemplateTypeId: [this.id],
        GraphDesc: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
        charIds: [''],
        GraphOrderId: [3],
        GraphTypeId: [0]
      }),
      'Graph4': this._formBuilder.group({
        GraphConfigId: [0],
        GraphTemplateTypeId: [this.id],
        GraphDesc: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
        charIds: [''],
        GraphOrderId: [4],
        GraphTypeId: [0]
      })
    })

    this.GetCharacteristicsForDDL();
    this.GetListOfGraphTypes();
    this.GetGraphConfigByTemplateId();
  }

  GetCharacteristicsForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCharacteristics)
      .subscribe(
      data => {
        this._mApp.HideLoader();
        if (data.json().Result != null)
          this.lstCharacteristics = data.json().Result;
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  GetListOfGraphTypes() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetListOfGraphTypes)
      .subscribe(
      data => {
        this._mApp.HideLoader();
        if (data.json().Result != null)
          this.graphTypes = data.json().Result;
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      )
  }
 

  onSubmit() {
    this.isSubmitted = true;
    if (this.graphForm.valid) {     
        let graphDto = this.graphForm.value;
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.UpsertGraphConfig, graphDto)
          .subscribe(
          data => {
            this._mApp.HideLoader();
            this._toastrService.success(data.json().Result, '');
            this._router.navigate(['/graphtemplates']);
          },
          error => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, '');
          }
          );
      }   
  }

  GetGraphConfigByTemplateId() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetGraphConfigsByTemplateId + this.id)
      .subscribe(
      data => {
        this._mApp.HideLoader();
        if (data.json().Result != null) {
          var response = data.json().Result;
          if (response.Graph1 != null)
            this.graphForm.controls['Graph1'].setValue(response.Graph1)
          if (response.Graph2 != null)
            this.graphForm.controls['Graph2'].setValue(response.Graph2)
          if (response.Graph3 != null)
            this.graphForm.controls['Graph3'].setValue(response.Graph3)
          if (response.Graph4 != null)
            this.graphForm.controls['Graph4'].setValue(response.Graph4)
        }
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result);
      }
      )
  }

  Clear() {
    this.graphForm.reset();
  }

}